import React from 'react'
import { Link } from 'gatsby'
import { Summary } from '@/components/Article/style.css'
import Ad970x250 from '@/components/Ads/970x250'
import data from '@/components/Feature/Rankings/Data'

const SummaryComponent = () => {
  const adid = 'div-gpt-ad-rankingu-4'
  const slug = 'ranking'

  return (
    <Summary>
      <div>
        <Ad970x250 adid={adid} slug={slug} />
      </div>
      <div className="container max-w-5xl mx-auto">
        <h1 className="text-center">
          <strong>Sumario</strong>
        </h1>
        <div className="list">
          {data.map((item, index) => {
            return (
              <ul key={index}>
                <li>
                  <Link to={item.link}>{item.name}</Link>
                  <ul>
                    {item.rankings.map((ranking, index) => {
                      return (
                        <li key={index}>
                          <Link to={ranking.link}>{ranking.name}</Link>
                        </li>
                      )
                    })}
                  </ul>
                </li>
              </ul>
            )
          })}
        </div>
      </div>
    </Summary>
  )
}

export default SummaryComponent
